module.exports = __webpack_public_path__ + "static/media/card-loader.3f259006.gif";